
import Vue from 'vue';
import Component from 'vue-class-component';
import ServiceStatusCard from '@/components/home/ServiceStatusCard.vue';
import UyapStatusCard from '@/components/home/UyapStatusCard.vue';
import UsageGuideCard from '@/components/home/UsageGuideCard.vue';

@Component({
  components: {
    ServiceStatusCard,
    UyapStatusCard,
    UsageGuideCard,
  },
})
export default class HomeView extends Vue {}
